import { Pipe, PipeTransform } from '@angular/core';
import { AccountType, Page, Role, Action } from '../../core/services/permissions/permissions';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { AccountService } from '../../core/services/account/account.service';
import { UserProfileService } from '../../core/services/user-profile/user-profile.service';

@Pipe({
  name: 'permissions',
  pure: false
})
export class PermissionsPipe implements PipeTransform {

  constructor(
    private permissionsService: PermissionsService,
    private accountService: AccountService,
    private userProfileService: UserProfileService
  ) {}

  transform(page: Page, feature: string, action: Action): boolean {
    const currentAccount = this.accountService.currentAccount.getValue();
    
    if (!currentAccount || Object.keys(currentAccount).length === 0) {
      return false;
    }

    const accountType: AccountType = currentAccount.isSubscriber
      ? AccountType.Subscriber
      : currentAccount.isSupplier
      ? AccountType.Supplier
      : currentAccount.isClient
      ? AccountType.Client
      : null;

    if (!accountType) {
      return false;
    }

    const userRole = this.getUserRole(currentAccount);
    if (!userRole) {
      return false;
    }

    return this.permissionsService.hasPermission(
      accountType,
      page,
      feature,
      userRole,
      action
    );
  }

  private getUserRole(currentAccount: any): Role | null {
    if (!currentAccount || !currentAccount.members) {
      return Role.Owner;
    }

    const currentUser = this.userProfileService.currentUser.getValue();
    if (!currentUser || !currentUser.id) {
      return Role.Owner;
    }

    const currentUserMember = currentAccount.members.find((member: any) => 
      member.user_id === currentUser.id
    );

    if (!currentUserMember) {
      return Role.Owner;
    }

    switch (currentUserMember.role) {
      case 0: return Role.Owner;
      case 1: return Role.MgrOps;
      case 2: return Role.CoOrdin;
      case 3: return Role.Admin;
      default: return Role.Owner;
    }
  }
} 